import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f2f5f7;
  padding: 2.204vw 5.313vw;
  min-height: 38.042vw;
  box-sizing: border-box;

  @media only screen and (max-width: 1100px) {
    padding: 25px 20px;
    position: relative;
    padding-bottom: 80px;
    min-height: 85vh;
  }
`;

export const SectionHeading = styled.section`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1100px) {
    display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  }
`;

export const TitleSpan = styled.span`
  font-family: 'Poppins';
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.073vw;
  margin-bottom: 1vw;
  font-size: 0.729vw;

  @media only screen and (max-width: 1100px) {
    letter-spacing: 1px;
    font-size: 3.2vw;
    margin-bottom: 0;
  }
`;

export const TitleHeading = styled.h1`
  font-family: 'Poppins';
  font-size: 2.604vw;
  margin-top: 0;
  margin-bottom: 2.104vw;
  font-weight: 600;

  @media only screen and (max-width: 1100px) {
    font-size: 6.5vw;
  }
`;

export const SectionGrid = styled.section`
  display: grid;
  grid-template-columns: ${(props) => (props.singleDemo ? '1fr' : '1fr 3.7fr')};
  grid-gap: 2.604vw;
  min-height: 26.542vw;

  @media only screen and (max-width: 1100px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5e7eb;
  justify-content: center;
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};

  @media only screen and (max-width: 1100px) {
    border: none;
  }
`;

export const TextInstruction = styled.span`
  font-family: 'Poppins';
  font-size: 0.833vw;
  font-weight: 600;
  margin-bottom: 1.667vw;

  // Mobile
  @media only screen and (max-width: 1100px) {
    font-size: 3vw;
    display: ${(props) => (props.hideOnMobile ? 'none' : 'flex')};
  }
`;

export const WrapMobileSingleDemoInstruction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const WrapMenuItems = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 32.8vw;
  height: 32.8vw;
  overflow-y: auto;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    background: transparent;
  }

  // Mobile
  @media only screen and (max-width: 1100px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'flex')};
    grid-template-columns: 1fr 1fr;
    gap: 2.4vw 4.8vw;
  }
`;

export const NavigateContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const NavigateTop = styled.div`
  /* transform: rotate(270deg); */
  height: 20px;
  width: 20px;
  align-self: center;
  cursor: pointer;
  margin-bottom: 20px;
  svg path {
    fill: #0071ce;
  }
`;

export const NavigateBottom = styled.div`
  transform: rotate(180deg);
  margin-right: 16px;
  height: 20px;
  width: 20px;
  align-self: center;
  cursor: pointer;
  svg path {
    fill: #0071ce;
  }
`;

export const WrapDemoVideo = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  video {
    max-height: ${(props) => props.smallDemo && '75vh'};
  }
`;

export const ShellVideoOptions = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  display: flex;
  flex-direction: column;
`;

export const TextVideoOptionsLabel = styled.div`
  color: #0071ce;
  font-size: 20px;
  margin-bottom: 10px;
`;

export const DemoVideo = styled.video`
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  aspect-ratio: 16/9;
  width: 100%;
  clip-path: inset(1px 1px);
  &:focus {
    outline: none;
  }
`;

export const DemoContent = styled.div`
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  aspect-ratio: 16/9;
`;

export const Illustration = styled.div`
  width: fit-content;
  overflow: hidden;
  max-height: ${(props) => props.smallDemo && '75vh'};
  width: ${(props) => (props.smallDemo ? '100%' : 'fit-content')};
  display: flex;
  justify-content: center;
`;

export const DemoContentImage = styled.iframe`
  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;
  height: 100%;
  border-radius: 16px;
`;

export const IllustrationImage = styled.img`
  max-width: 100%;
  border-radius: 16px;
  object-fit: contain;
`;

export const DemoGrid = styled.div`
  display: grid;
  grid-template-columns: 2.82fr 1fr;
  grid-gap: 2.604vw;

  @media only screen and (max-width: 1100px) {
    display: flex;
    flex-direction: column;
  }
`;

export const DescriptionTitle = styled.div`
  font-weight: 600;
  font-size: 1.25vw;
  font-family: 'Poppins';
  line-height: 1.3;
  @media only screen and (max-width: 1100px) {
    font-size: 4vw;
  }
`;

export const DescriptionItem = styled.p`
  font-size: 0.833vw;
  font-family: 'Poppins';
  &:last-of-type {
    margin-bottom: 2.083vw;
  }
  @media only screen and (max-width: 1100px) {
    font-size: 2.833vw;
    &:last-of-type {
      margin-bottom: 5vw;
    }
  }
`;

export const SectionCta = styled.div`
  display: flex;

  @media only screen and (max-width: 1100px) {
    flex-direction: row-reverse;
    justify-content: center;
    position: absolute;
    width: 100%;
    padding: 3.2vw;
    left: 0;
    background: white;
    position: fixed;
    height: 100px;
    top: calc(100% - 100px);
    box-sizing: border-box;
  }
`;

export const Button = styled.button`
  font-family: 'Poppins';
  font-size: 0.833vw;
  border: none;
  border-radius: 4px;
  width: 7.813vw;
  height: 2.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  @media only screen and (max-width: 1100px) {
    border-radius: 2px;
    width: 32vw;
    height: 7.2vw;
    font-size: 2.8vw;
  }
`;

export const ButtonPrimary = styled(Button)`
  background: #0071ce;
  color: white;
  font-weight: 600;
  &:hover {
    background: #005daa;
  }

  ${(props) =>
    props.responsive &&
    `
    padding: 11px 16px;
    height: auto;
    min-height: 2.5vw;
    width: auto;

    @media only screen and (max-width: 1100px) {
      min-height: 7.2vw;
      max-height: 10vw;
    }  
    `}
`;
export const ButtonSecondary = styled(Button)`
  background: transparent;
  color: #0071ce;

  @media only screen and (max-width: 1100px) {
    background-color: #e5e7eb;
    color: #415364;
    margin-right: ${(props) => props.addMargin && '4.8vw'};
  }
`;

export const StyledDemo = styled.div`
  font-family: 'Poppins';
  box-sizing: 'border-box';
  color: #415364;

  @media only screen and (max-width: 1100px) {
    padding: 20px 0 0 0;
    padding: ${(props) => props.selectedDemo && '50px 0 0 0'}; // Add mobile header height - 50p
  }
`;

export default StyledDemo;
